import React, { useState, useEffect, useRef } from "react";
import { ToastContainer, toast } from "react-toastify";
import './ListDevices.scss'
import "react-toastify/dist/ReactToastify.css";
import SearchBarComponent from "../../components/searchBar/searchBarComponent";
import { ReactComponent as UsersSVG } from "../../images/new_ui/add_user.svg";
import DeviceName from "../../images/new_ui/Devicename.svg";
import DeviceId from "../../images/new_ui/deviceid.svg";
import MacId from "../../images/new_ui/macicon.svg"
import userid from "../../images/new_ui/userid_image.svg";
import axios from "axios";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { sidebarReducer } from "../../Redux/store";
import { Route, Navigate, useNavigate } from "react-router-dom";

function ListDevices() {
  const dispatch = useDispatch();

  //API related selectors
  const token = useSelector((state) => state.AccessTocken.accessTocken);
  const apiLoad = useSelector((state) => state.sidebar.apiLoad);

  useEffect(() => {
    getUsersList();
  }, []);
  const [DeviceData,setDeviceData] =useState([])
  async function getUsersList() {
    dispatch(sidebarReducer.apiLoad(true));
    // setApiLaod(true);
    await axios

      .get(
        "devlicense/listAll",
        {
          headers: {
            Authorization:
              "Bearer" + " " + sessionStorage.getItem("access_token"),
          },
        }
      )
      

      .then((response) => {
        // console.log(" response list users", response.data.data);
        if (response.status === 200) {
          dispatch(sidebarReducer.apiLoad(false));
          //setApiLaod(false);
          // console.log("getAllUsers2", response.data.data);
          setDeviceData(response.data.data);
          // console.log("DeviceData",DeviceData)
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })
      .catch((err) => {
        dispatch(sidebarReducer.stringUpdate("AppDown"));
      });
  }

  const navigate = useNavigate();
  return (
    <div className="list-devices">
      <ToastContainer closeButton={false} />
      <div className="container-fluid">
        <div className="container">
          <div className="row">
            <SearchBarComponent className="search-bar-div" />
          </div>
        </div>
        <div className="container">
          <div className="device-table-container">
            <div className="user-table-container">
              <div className="title-area">
                <h5>Registered Device List</h5>
                <button
                  className="add-screen-button"
                  type="button"
                  onClick={() =>
                    navigate("/add-device")
                  }
                >
                  <UsersSVG
                    style={{ width: "40px", height: "auto", cursor: "pointer" }}
                  />
                  <p>Add New Device</p>
                </button>
              </div>
              <hr />
              <div className="">
                <div className="container-fluid g-0">
                  <div className="table-wrapper-scroll-y user-list-table">
                    {apiLoad ? (
                      <div
                        style={{
                          height: "80vh",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <div className="spinnerApi"></div>
                      </div>
                    ) : (
                    <>
                     
                      <table stickyHeader="true" aria-label="sticky table">
                        <thead>
                          <tr>
                          <th>
                              <img className="filter-icon" src={DeviceName} alt="Device Name" />
                           Device Name
                            </th>
                            <th>
                              <img className="filter-icon" src={DeviceId} alt="Device Id" />
                              Device ID
                            </th>
                            <th>
                              <img className="filter-icon" src={MacId} alt="Mac Id" />
                              Mac ID
                            </th>
                           
                          </tr>
                        </thead>
                        <tbody>
                          {DeviceData.map((item) => (
                            <tr key={item.te_username}>
                              <td className="responsive-screen">
                                {item.te_device_name? item.te_device_name : "N/A"} {" "}
                              </td>
                              <td className="responsive-screen">
                              <div className=" invoice-number" title={item.te_deviceid} >{item.te_deviceid ? item.te_deviceid : "N/A"} </div> 
                              </td>
                              <td className="responsive-screen">
                                {item.te_mac_id? item.te_mac_id : "N/A"} {" "}
                              </td>  
                            </tr>
                          ))}
                        </tbody>
                      </table>
                       
                    </>
                    )} 
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ListDevices;
